import { t } from '@transifex/native';
import { z } from 'zod';

export const emailSchema = z.object({
  email: z.string().email(t('Please enter a valid email address')),
});

export const progressiveValidationMapping = {
  charLimit: 'Password must be at least 8 characters',
  number: 'Password must contain at least 1 number',
  specialChar: 'Password must contain at least 1 special character',
  letter: 'Password must contain at least 1 letter',
};

export const passwordSchema = z
  .string()
  .min(8, progressiveValidationMapping.charLimit)
  .regex(/[A-Za-z]/, progressiveValidationMapping.letter)
  .regex(/[0-9]/, progressiveValidationMapping.number)
  .regex(/[^A-Za-z0-9]/, progressiveValidationMapping.specialChar);
